import React from 'react';
import { UserContext } from './context';

export default class AuthProvider extends React.Component {
  componentDidMount() {
    const { verify } = this.props;
    verify();
  }

  render() {
    const { children, errors, user, club, loading, login, logout, register } =
      this.props;
    const isAuthenticated = !!user;
    return (
      <UserContext.Provider
        value={{
          user,
          login,
          club,
          logout,
          register,
          errors,
        }}
      >
        {children({
          loading,
          isAuthenticated,
          user,
          club,
          errors,
        })}
      </UserContext.Provider>
    );
  }
}
